/**
 * llm-helpers.ts
 * llm.ts 的纯函数辅助模块（无 Pinia 运行时依赖，便于离线单测）
 */

/** 仅供 UI 展示、绝不回传模型的 assistant 消息字段。 */
const DISPLAY_ONLY_FIELDS = ['innerVoice', 'reasoning'] as const

/**
 * 回传模型前剔除 assistant 消息的展示专用字段（innerVoice / 历史遗留的 reasoning）。
 *
 * ⚠️ 安全关键：这些内容存进记录仅供 UI 展示；若回灌给模型会污染上下文、
 * 浪费 token，且属 Claude 复读根因相邻风险区（见记忆 meowchat-claude-复读根因）。
 * 必须在组装上游 messages 前统一剥离。返回浅拷贝，不改动原数组。
 */
export function stripDisplayOnlyFields<T>(
  messages: readonly T[],
): T[] {
  return messages.map((m) => {
    if (!m || typeof m !== 'object')
      return m
    if (!DISPLAY_ONLY_FIELDS.some(f => f in m))
      return m
    const rest = { ...(m as Record<string, unknown>) }
    for (const f of DISPLAY_ONLY_FIELDS)
      delete rest[f]
    return rest as T
  })
}
